import React, { ReactNode } from 'react';

interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon: ReactNode;
  trend?: {
    value: string;
    isPositive: boolean;
  };
  className?: string;
}

export function StatCard({ title, value, subtitle, icon, trend, className = '' }: StatCardProps) {
  return (
    <div
      className={`p-5 rounded-2xl ios-card ios-press relative overflow-hidden group transition-all select-none ${className}`}
    >
      <div className="flex items-center justify-between">
        <span className="text-[11px] font-bold text-zinc-500 dark:text-zinc-400 tracking-wider uppercase">
          {title}
        </span>
        <div className="p-2.5 rounded-xl bg-black/[0.04] dark:bg-zinc-800/80 border border-black/5 dark:border-white/10 text-pulse-blue group-hover:scale-105 transition-transform shadow-sm">
          {icon}
        </div>
      </div>

      <div className="mt-4 flex items-baseline gap-2">
        <span className="text-3xl font-extrabold tracking-tight text-zinc-900 dark:text-white">
          {value}
        </span>
        {trend && (
          <span
            className={`text-xs font-bold ${
              trend.isPositive ? 'text-emerald-600 dark:text-emerald-400' : 'text-rose-600 dark:text-rose-400'
            }`}
          >
            {trend.value}
          </span>
        )}
      </div>

      {subtitle && <p className="mt-1 text-xs text-zinc-500 dark:text-zinc-400 font-medium">{subtitle}</p>}
    </div>
  );
}
